import type { CatalogueKind, ICatalogueItem, ISubscription, PricingModel } from '../../types';

export const PRICING_LABELS: Record<PricingModel, string> = {
  flat: 'Flat, per month',
  per_venue: 'Per venue, per month',
  per_user: 'Per user, per month',
  one_off: 'One-off',
};

export const PRICING_SHORT: Record<PricingModel, string> = {
  flat: '/ month',
  per_venue: '/ venue / month',
  per_user: '/ user / month',
  one_off: 'one-off',
};

export const KIND_LABELS: Record<CatalogueKind, string> = {
  platform: 'Platform',
  addon: 'Add-on',
  tool: 'Tool',
  service: 'Service',
};

export const money = (value: number | null, currency = 'GBP'): string => {
  if (value === null) {
    return '—';
  }
  const symbol = currency === 'GBP' ? '£' : `${currency} `;
  return `${symbol}${value.toLocaleString('en-GB', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
};

/** Monthly value of one subscription line, for display. */
export const monthlyValue = (sub: ISubscription): number => {
  if (sub.period === 'one_off') {
    return 0;
  }
  const units = sub.quantity ?? 1;
  return (sub.period === 'annual' ? sub.price / 12 : sub.price) * units;
};

export type LineState = 'live' | 'upcoming' | 'ended';

export const lineState = (
  sub: ISubscription,
  today = new Date().toISOString().slice(0, 10),
): LineState => {
  if (sub.starts_on > today) {
    return 'upcoming';
  }
  if (sub.ends_on !== null && sub.ends_on < today) {
    return 'ended';
  }
  return 'live';
};

export const addDays = (iso: string, days: number): string => {
  const date = new Date(`${iso}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};

export const quantityFor = (
  item: ICatalogueItem,
  venues: number | null,
  users: number | null,
): number | null => {
  if (item.pricing_model === 'per_venue') {
    return venues ?? 0;
  }
  if (item.pricing_model === 'per_user') {
    return users ?? 0;
  }
  return null;
};
